<template>
	<div>
		<header>
			<div class="left-menu">
				<router-link :to="(isLoggedIn ? '/dashboard' : '/home')">
					<img src="/static/img/eremit-logo.png" alt="eremit"/>
				</router-link >		
			</div>
			<div class="right-menu">
				<ul>
					<li class="msg-welcome" v-if="isLoggedIn">
						Welcome, <span>{{userInfo.Name}}</span>
					</li>
					<li class="navopener" v-if="isLoggedIn">
						<button type="button" class="menubar" style="font-size:30px;cursor:pointer" @click="openNav">
							<img src="/static/img/icons/Hamburger.png" alt=""/>
						</button>
					</li>
				</ul>
			</div>
		</header>
		<div id="mySidenav" class="sidenav" ref="mySidenav" v-if="isLoggedIn">
			<div class="sidebar"></div>
			<a href="javascript:void(0)" class="closebtn" @click="closeNav">
				<img src="/static/img/icons/close.png" alt=""/>
			</a>
			<div class="main-menu">
				<ul>
					<li>
						<router-link :to="'/dashboard'">
							<img src="/static/img/icons/Dashboard-Icon.png" alt="" /> Dashboard
						</router-link>
					</li>
					<li>
						<router-link :to="'/transaction'">
							<img src="/static/img/icons/History-Icon.png" alt="" /> History
						</router-link>

					</li>
					<li>
						<router-link :to="'/recipient'">
							<img src="/static/img/icons/Recipient-Icon.png" alt="" /> Recipient
						</router-link>

					</li>
					<li>
						<router-link :to="'/einvoicetransactionlist'">
							<img src="/static/img/icons/einvoice.png" alt="" /> E-Invoice
						</router-link>
					</li>
					<li>
						<img src="/static/img/icons/Setting-Icon.png" alt="" /> Setting
					</li>
					<li>
						<ul>
							<li>
								<router-link :to="'/IncreaseLimitDashboard'" v-if="userInfo.EnableLimitRequest=='true' ">*Upgrade Your Account Limit</router-link>

							</li>
							<li>
								<router-link :to="'/changeemail'">*Change Email</router-link>

							</li>
							<li>
								<router-link :to="'/changephone'">*Change Phone</router-link>

							</li>
							<li>
								<router-link :to="'/changepassword'">*Change Password</router-link>

							</li>
							<li>
								<router-link :to="'/profile'">*Change Profile</router-link>

							</li>
							<li>
								<router-link :to="'/changepassphrase'">*Change Security Phrase</router-link>

							</li>
							<li>
								<router-link :to="'/debitcards'">*Manage Debit Card</router-link>
							</li>
							<!-- <li>
		<router-link :to="'/profile'">*Set Rate Alert</router-link >

	</li> -->
							<li>
								<router-link :to="'/upgradetokyc'" v-if="userInfo.IsVerifiedEKYCUser == 'true'">*Upgrade your Account Limit</router-link>
								<!--<router-link :to="'/upgradetokyc'">*Upgrade To KYC</router-link>-->
							</li>
							<li>
								<a v-if="userInfo.IsUnVerifiedKYCUser == 'true'" @click="downloadInvoice">
									<i class="material-icons">download</i> Download Registration Form
								</a>
							</li>
						</ul>
					</li>
					<li style="display:none">
						<router-link :to="'/support'">
							<img src="/static/img/icons/Support-Icon.png" alt="" /> Support
						</router-link>

					</li>
				</ul>
				<div class="menubar-logout">
					<button class="main-btn" @click="logOut">Logout</button>
				</div>
			</div>

		</div>

	</div>

</template>
<script>
		import kendo from "@progress/kendo-ui";
		import CommonService from "../services/common";
		import Vue from "vue";

		export default {
			name: "header-dropdown",
			created() {
				this.userInfo = CommonService.getUserInfo();
			},
			computed:{
				isLoggedIn() {
					return CommonService.isAuthenticated();	
				}
			},
			methods: {
				openNav: function () { 
					const el = this.$refs.mySidenav;			
					el.classList.add("sidenav-full-width");
				
				},
				closeNav: function () {
						const el = this.$refs.mySidenav;		
						el.classList.remove("sidenav-full-width");
				},
				logOut: function (e) {
					var self = this;
					e.preventDefault();
					kendo.confirm("Are you sure to logout?", "Confirm").then(
						function () {
							CommonService.logOut();
						},
						function () { }
					);
				},
				downloadInvoice: function () {
					var token = commonService.getStorage('token');
					var cvrForm = document.createElement("form");
					document.body.appendChild(cvrForm);
					cvrForm.setAttribute("action", CommonService.getBaseUrl("/") + "customer/upgradetokyc");
					cvrForm.setAttribute("method", "post");
					cvrForm.setAttribute("target", "_blank");
					var formContent = "<input type='hidden' name='Token' value='" + token + "'/>";
					cvrForm.innerHTML = formContent;
					cvrForm.submit();
					document.body.removeChild(cvrForm);

				}
			},
			data() {
				return {
					userInfo: null,
					toggleMenu: false,					
				};
			}	
		}
	</script>
